/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AppThemeImageType } from '../models/app-theme-image-type';
import { ApplicationFeatureDto } from '../models/application-feature-dto';
import { ApplicationInfoDto } from '../models/application-info-dto';
import { ApplicationInfoDtoBaseResponse } from '../models/application-info-dto-base-response';
import { ApplicationThemeDto } from '../models/application-theme-dto';
import { ApplicationThemeDtoBaseResponse } from '../models/application-theme-dto-base-response';
import { AuditFilterDto } from '../models/audit-filter-dto';
import { AuditLogDto } from '../models/audit-log-dto';
import { AuditLogDtoBaseResponse } from '../models/audit-log-dto-base-response';
import { AuditLogDtoListBaseResponse } from '../models/audit-log-dto-list-base-response';
import { AuditLogDtoPagedResultDtoBaseResponse } from '../models/audit-log-dto-paged-result-dto-base-response';
import { BooleanBaseResponse } from '../models/boolean-base-response';
import { DepotDto } from '../models/depot-dto';
import { DepotDtoBaseResponse } from '../models/depot-dto-base-response';
import { DepotDtoListBaseResponse } from '../models/depot-dto-list-base-response';
import { FeatureListBaseResponse } from '../models/feature-list-base-response';
import { GeneratorDto } from '../models/generator-dto';
import { GeneratorDtoBaseResponse } from '../models/generator-dto-base-response';
import { GeneratorDtoListBaseResponse } from '../models/generator-dto-list-base-response';
import { GeneratorValidationResultDtoBaseResponse } from '../models/generator-validation-result-dto-base-response';
import { GlobalRefuelConfigurationDto } from '../models/global-refuel-configuration-dto';
import { GlobalRefuelConfigurationDtoBaseResponse } from '../models/global-refuel-configuration-dto-base-response';
import { ImportMappingDto } from '../models/import-mapping-dto';
import { ImportMappingDtoBaseResponse } from '../models/import-mapping-dto-base-response';
import { ImportMappingDtoListBaseResponse } from '../models/import-mapping-dto-list-base-response';
import { ImportPreviewDtoBaseResponse } from '../models/import-preview-dto-base-response';
import { PreviewRequestDto } from '../models/preview-request-dto';
import { RefuelRuleDto } from '../models/refuel-rule-dto';
import { RefuelRuleDtoBaseResponse } from '../models/refuel-rule-dto-base-response';
import { RefuelRuleDtoListBaseResponse } from '../models/refuel-rule-dto-list-base-response';
import { RefuelScheduleTypeNullableBaseResponse } from '../models/refuel-schedule-type-nullable-base-response';
import { VehicleDto } from '../models/vehicle-dto';
import { VehicleDtoBaseResponse } from '../models/vehicle-dto-base-response';
import { VehicleDtoListBaseResponse } from '../models/vehicle-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiSettingsAllowedFeaturesGet
   */
  static readonly ApiSettingsAllowedFeaturesGetPath = '/api/Settings/allowed-features';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAllowedFeaturesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAllowedFeaturesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<FeatureListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAllowedFeaturesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FeatureListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAllowedFeaturesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAllowedFeaturesGet$Plain(params?: {
  }): Observable<FeatureListBaseResponse> {

    return this.apiSettingsAllowedFeaturesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<FeatureListBaseResponse>) => r.body as FeatureListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAllowedFeaturesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAllowedFeaturesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<FeatureListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAllowedFeaturesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FeatureListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAllowedFeaturesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAllowedFeaturesGet$Json(params?: {
  }): Observable<FeatureListBaseResponse> {

    return this.apiSettingsAllowedFeaturesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<FeatureListBaseResponse>) => r.body as FeatureListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsToggleFeaturePut
   */
  static readonly ApiSettingsToggleFeaturePutPath = '/api/Settings/toggle-feature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsToggleFeaturePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsToggleFeaturePut$Plain$Response(params?: {
    body?: ApplicationFeatureDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsToggleFeaturePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsToggleFeaturePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsToggleFeaturePut$Plain(params?: {
    body?: ApplicationFeatureDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsToggleFeaturePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsToggleFeaturePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsToggleFeaturePut$Json$Response(params?: {
    body?: ApplicationFeatureDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsToggleFeaturePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsToggleFeaturePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsToggleFeaturePut$Json(params?: {
    body?: ApplicationFeatureDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsToggleFeaturePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsThemeGet
   */
  static readonly ApiSettingsThemeGetPath = '/api/Settings/theme';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsThemeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsThemeGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ApplicationThemeDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsThemeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationThemeDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsThemeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsThemeGet$Plain(params?: {
  }): Observable<ApplicationThemeDtoBaseResponse> {

    return this.apiSettingsThemeGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationThemeDtoBaseResponse>) => r.body as ApplicationThemeDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsThemeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsThemeGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ApplicationThemeDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsThemeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationThemeDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsThemeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsThemeGet$Json(params?: {
  }): Observable<ApplicationThemeDtoBaseResponse> {

    return this.apiSettingsThemeGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationThemeDtoBaseResponse>) => r.body as ApplicationThemeDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsUpdateThemePut
   */
  static readonly ApiSettingsUpdateThemePutPath = '/api/Settings/update-theme';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateThemePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateThemePut$Plain$Response(params?: {
    body?: ApplicationThemeDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateThemePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateThemePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateThemePut$Plain(params?: {
    body?: ApplicationThemeDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateThemePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateThemePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateThemePut$Json$Response(params?: {
    body?: ApplicationThemeDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateThemePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateThemePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateThemePut$Json(params?: {
    body?: ApplicationThemeDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateThemePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsUpdateThemeDimCoverBackgroundPut
   */
  static readonly ApiSettingsUpdateThemeDimCoverBackgroundPutPath = '/api/Settings/update-theme-dim-cover-background';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateThemeDimCoverBackgroundPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsUpdateThemeDimCoverBackgroundPut$Plain$Response(params?: {
    dimCoverBackground?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateThemeDimCoverBackgroundPutPath, 'put');
    if (params) {
      rb.query('dimCoverBackground', params.dimCoverBackground, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateThemeDimCoverBackgroundPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsUpdateThemeDimCoverBackgroundPut$Plain(params?: {
    dimCoverBackground?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateThemeDimCoverBackgroundPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateThemeDimCoverBackgroundPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsUpdateThemeDimCoverBackgroundPut$Json$Response(params?: {
    dimCoverBackground?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateThemeDimCoverBackgroundPutPath, 'put');
    if (params) {
      rb.query('dimCoverBackground', params.dimCoverBackground, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateThemeDimCoverBackgroundPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsUpdateThemeDimCoverBackgroundPut$Json(params?: {
    dimCoverBackground?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateThemeDimCoverBackgroundPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsUpdateCompanyImagePost
   */
  static readonly ApiSettingsUpdateCompanyImagePostPath = '/api/Settings/update-company-image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateCompanyImagePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiSettingsUpdateCompanyImagePost$Plain$Response(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateCompanyImagePostPath, 'post');
    if (params) {
      rb.query('imageType', params.imageType, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateCompanyImagePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiSettingsUpdateCompanyImagePost$Plain(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateCompanyImagePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateCompanyImagePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiSettingsUpdateCompanyImagePost$Json$Response(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateCompanyImagePostPath, 'post');
    if (params) {
      rb.query('imageType', params.imageType, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateCompanyImagePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiSettingsUpdateCompanyImagePost$Json(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateCompanyImagePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDeleteCompanyImageDelete
   */
  static readonly ApiSettingsDeleteCompanyImageDeletePath = '/api/Settings/delete-company-image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDeleteCompanyImageDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDeleteCompanyImageDelete$Plain$Response(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDeleteCompanyImageDeletePath, 'delete');
    if (params) {
      rb.query('imageType', params.imageType, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDeleteCompanyImageDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDeleteCompanyImageDelete$Plain(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsDeleteCompanyImageDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDeleteCompanyImageDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDeleteCompanyImageDelete$Json$Response(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDeleteCompanyImageDeletePath, 'delete');
    if (params) {
      rb.query('imageType', params.imageType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDeleteCompanyImageDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDeleteCompanyImageDelete$Json(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsDeleteCompanyImageDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGetCompanyImageGet
   */
  static readonly ApiSettingsGetCompanyImageGetPath = '/api/Settings/get-company-image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGetCompanyImageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGetCompanyImageGet$Response(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGetCompanyImageGetPath, 'get');
    if (params) {
      rb.query('imageType', params.imageType, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGetCompanyImageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGetCompanyImageGet(params?: {

    /**
     * 0 &#x3D; CompanyLogo
     * 
     * 1 &#x3D; LoginLogo
     * 
     * 2 &#x3D; CoverLogo
     * 
     * 3 &#x3D; CoverBackground
     */
    imageType?: AppThemeImageType;
  }): Observable<string> {

    return this.apiSettingsGetCompanyImageGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiSettingsAppInfoGet
   */
  static readonly ApiSettingsAppInfoGetPath = '/api/Settings/app-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAppInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAppInfoGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ApplicationInfoDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAppInfoGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationInfoDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAppInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAppInfoGet$Plain(params?: {
  }): Observable<ApplicationInfoDtoBaseResponse> {

    return this.apiSettingsAppInfoGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationInfoDtoBaseResponse>) => r.body as ApplicationInfoDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAppInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAppInfoGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ApplicationInfoDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAppInfoGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApplicationInfoDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAppInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAppInfoGet$Json(params?: {
  }): Observable<ApplicationInfoDtoBaseResponse> {

    return this.apiSettingsAppInfoGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ApplicationInfoDtoBaseResponse>) => r.body as ApplicationInfoDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsUpdateAppInfoPut
   */
  static readonly ApiSettingsUpdateAppInfoPutPath = '/api/Settings/update-app-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateAppInfoPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateAppInfoPut$Plain$Response(params?: {
    body?: ApplicationInfoDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateAppInfoPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateAppInfoPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateAppInfoPut$Plain(params?: {
    body?: ApplicationInfoDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateAppInfoPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsUpdateAppInfoPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateAppInfoPut$Json$Response(params?: {
    body?: ApplicationInfoDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsUpdateAppInfoPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsUpdateAppInfoPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsUpdateAppInfoPut$Json(params?: {
    body?: ApplicationInfoDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsUpdateAppInfoPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorsGet
   */
  static readonly ApiSettingsGeneratorsGetPath = '/api/Settings/generators';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<GeneratorDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorsGet$Plain(params?: {
  }): Observable<GeneratorDtoListBaseResponse> {

    return this.apiSettingsGeneratorsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoListBaseResponse>) => r.body as GeneratorDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<GeneratorDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorsGet$Json(params?: {
  }): Observable<GeneratorDtoListBaseResponse> {

    return this.apiSettingsGeneratorsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoListBaseResponse>) => r.body as GeneratorDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorIdGet
   */
  static readonly ApiSettingsGeneratorIdGetPath = '/api/Settings/generator/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdGet$Plain(params: {
    id: number;
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdGet$Json(params: {
    id: number;
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorIdDelete
   */
  static readonly ApiSettingsGeneratorIdDeletePath = '/api/Settings/generator/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsGeneratorIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsGeneratorIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorByGenidGenIdGet
   */
  static readonly ApiSettingsGeneratorByGenidGenIdGetPath = '/api/Settings/generator-by-genid/{genId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorByGenidGenIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorByGenidGenIdGet$Plain$Response(params: {
    genId: string;
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorByGenidGenIdGetPath, 'get');
    if (params) {
      rb.path('genId', params.genId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorByGenidGenIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorByGenidGenIdGet$Plain(params: {
    genId: string;
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorByGenidGenIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorByGenidGenIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorByGenidGenIdGet$Json$Response(params: {
    genId: string;
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorByGenidGenIdGetPath, 'get');
    if (params) {
      rb.path('genId', params.genId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorByGenidGenIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorByGenidGenIdGet$Json(params: {
    genId: string;
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorByGenidGenIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorPut
   */
  static readonly ApiSettingsGeneratorPutPath = '/api/Settings/generator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPut$Plain$Response(params?: {
    body?: GeneratorDto
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPut$Plain(params?: {
    body?: GeneratorDto
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPut$Json$Response(params?: {
    body?: GeneratorDto
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPut$Json(params?: {
    body?: GeneratorDto
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorPost
   */
  static readonly ApiSettingsGeneratorPostPath = '/api/Settings/generator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPost$Plain$Response(params?: {
    body?: GeneratorDto
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPost$Plain(params?: {
    body?: GeneratorDto
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPost$Json$Response(params?: {
    body?: GeneratorDto
  }): Observable<StrictHttpResponse<GeneratorDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsGeneratorPost$Json(params?: {
    body?: GeneratorDto
  }): Observable<GeneratorDtoBaseResponse> {

    return this.apiSettingsGeneratorPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorDtoBaseResponse>) => r.body as GeneratorDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsValidateGeneratorIdsPost
   */
  static readonly ApiSettingsValidateGeneratorIdsPostPath = '/api/Settings/validate-generator-ids';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsValidateGeneratorIdsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsValidateGeneratorIdsPost$Plain$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsValidateGeneratorIdsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsValidateGeneratorIdsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsValidateGeneratorIdsPost$Plain(params?: {
    body?: Array<string>
  }): Observable<GeneratorValidationResultDtoBaseResponse> {

    return this.apiSettingsValidateGeneratorIdsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>) => r.body as GeneratorValidationResultDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsValidateGeneratorIdsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsValidateGeneratorIdsPost$Json$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsValidateGeneratorIdsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsValidateGeneratorIdsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsValidateGeneratorIdsPost$Json(params?: {
    body?: Array<string>
  }): Observable<GeneratorValidationResultDtoBaseResponse> {

    return this.apiSettingsValidateGeneratorIdsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GeneratorValidationResultDtoBaseResponse>) => r.body as GeneratorValidationResultDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsGeneratorRefuelScheduleGenIdGet
   */
  static readonly ApiSettingsGeneratorRefuelScheduleGenIdGetPath = '/api/Settings/generator-refuel-schedule/{genId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorRefuelScheduleGenIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorRefuelScheduleGenIdGet$Plain$Response(params: {
    genId: string;
  }): Observable<StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorRefuelScheduleGenIdGetPath, 'get');
    if (params) {
      rb.path('genId', params.genId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorRefuelScheduleGenIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorRefuelScheduleGenIdGet$Plain(params: {
    genId: string;
  }): Observable<RefuelScheduleTypeNullableBaseResponse> {

    return this.apiSettingsGeneratorRefuelScheduleGenIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>) => r.body as RefuelScheduleTypeNullableBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsGeneratorRefuelScheduleGenIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorRefuelScheduleGenIdGet$Json$Response(params: {
    genId: string;
  }): Observable<StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsGeneratorRefuelScheduleGenIdGetPath, 'get');
    if (params) {
      rb.path('genId', params.genId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsGeneratorRefuelScheduleGenIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsGeneratorRefuelScheduleGenIdGet$Json(params: {
    genId: string;
  }): Observable<RefuelScheduleTypeNullableBaseResponse> {

    return this.apiSettingsGeneratorRefuelScheduleGenIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelScheduleTypeNullableBaseResponse>) => r.body as RefuelScheduleTypeNullableBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelRulesGet
   */
  static readonly ApiSettingsRefuelRulesGetPath = '/api/Settings/refuel-rules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRulesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<RefuelRuleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRulesGet$Plain(params?: {
  }): Observable<RefuelRuleDtoListBaseResponse> {

    return this.apiSettingsRefuelRulesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoListBaseResponse>) => r.body as RefuelRuleDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRulesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<RefuelRuleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRulesGet$Json(params?: {
  }): Observable<RefuelRuleDtoListBaseResponse> {

    return this.apiSettingsRefuelRulesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoListBaseResponse>) => r.body as RefuelRuleDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelRuleIdGet
   */
  static readonly ApiSettingsRefuelRuleIdGetPath = '/api/Settings/refuel-rule/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRuleIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRuleIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRuleIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdGet$Plain(params: {
    id: number;
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRuleIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRuleIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRuleIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRuleIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdGet$Json(params: {
    id: number;
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRuleIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelRuleIdDelete
   */
  static readonly ApiSettingsRefuelRuleIdDeletePath = '/api/Settings/refuel-rule/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRuleIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRuleIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRuleIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsRefuelRuleIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRuleIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRuleIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRuleIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelRuleIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsRefuelRuleIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelRulePut
   */
  static readonly ApiSettingsRefuelRulePutPath = '/api/Settings/refuel-rule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePut$Plain$Response(params?: {
    body?: RefuelRuleDto
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePut$Plain(params?: {
    body?: RefuelRuleDto
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRulePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePut$Json$Response(params?: {
    body?: RefuelRuleDto
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePut$Json(params?: {
    body?: RefuelRuleDto
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRulePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelRulePost
   */
  static readonly ApiSettingsRefuelRulePostPath = '/api/Settings/refuel-rule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePost$Plain$Response(params?: {
    body?: RefuelRuleDto
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePost$Plain(params?: {
    body?: RefuelRuleDto
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRulePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelRulePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePost$Json$Response(params?: {
    body?: RefuelRuleDto
  }): Observable<StrictHttpResponse<RefuelRuleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelRulePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RefuelRuleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelRulePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelRulePost$Json(params?: {
    body?: RefuelRuleDto
  }): Observable<RefuelRuleDtoBaseResponse> {

    return this.apiSettingsRefuelRulePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RefuelRuleDtoBaseResponse>) => r.body as RefuelRuleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelConfigurationGet
   */
  static readonly ApiSettingsRefuelConfigurationGetPath = '/api/Settings/refuel-configuration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelConfigurationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelConfigurationGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelConfigurationGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelConfigurationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelConfigurationGet$Plain(params?: {
  }): Observable<GlobalRefuelConfigurationDtoBaseResponse> {

    return this.apiSettingsRefuelConfigurationGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>) => r.body as GlobalRefuelConfigurationDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelConfigurationGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelConfigurationGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelConfigurationGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelConfigurationGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsRefuelConfigurationGet$Json(params?: {
  }): Observable<GlobalRefuelConfigurationDtoBaseResponse> {

    return this.apiSettingsRefuelConfigurationGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>) => r.body as GlobalRefuelConfigurationDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsRefuelConfigurationPut
   */
  static readonly ApiSettingsRefuelConfigurationPutPath = '/api/Settings/refuel-configuration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelConfigurationPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelConfigurationPut$Plain$Response(params?: {
    body?: GlobalRefuelConfigurationDto
  }): Observable<StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelConfigurationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelConfigurationPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelConfigurationPut$Plain(params?: {
    body?: GlobalRefuelConfigurationDto
  }): Observable<GlobalRefuelConfigurationDtoBaseResponse> {

    return this.apiSettingsRefuelConfigurationPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>) => r.body as GlobalRefuelConfigurationDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsRefuelConfigurationPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelConfigurationPut$Json$Response(params?: {
    body?: GlobalRefuelConfigurationDto
  }): Observable<StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsRefuelConfigurationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsRefuelConfigurationPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsRefuelConfigurationPut$Json(params?: {
    body?: GlobalRefuelConfigurationDto
  }): Observable<GlobalRefuelConfigurationDtoBaseResponse> {

    return this.apiSettingsRefuelConfigurationPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<GlobalRefuelConfigurationDtoBaseResponse>) => r.body as GlobalRefuelConfigurationDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehiclesGet
   */
  static readonly ApiSettingsVehiclesGetPath = '/api/Settings/vehicles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<VehicleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesGet$Plain(params?: {
  }): Observable<VehicleDtoListBaseResponse> {

    return this.apiSettingsVehiclesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoListBaseResponse>) => r.body as VehicleDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<VehicleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesGet$Json(params?: {
  }): Observable<VehicleDtoListBaseResponse> {

    return this.apiSettingsVehiclesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoListBaseResponse>) => r.body as VehicleDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehiclesActiveGet
   */
  static readonly ApiSettingsVehiclesActiveGetPath = '/api/Settings/vehicles/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclesActiveGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesActiveGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<VehicleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclesActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclesActiveGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesActiveGet$Plain(params?: {
  }): Observable<VehicleDtoListBaseResponse> {

    return this.apiSettingsVehiclesActiveGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoListBaseResponse>) => r.body as VehicleDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclesActiveGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesActiveGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<VehicleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclesActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclesActiveGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehiclesActiveGet$Json(params?: {
  }): Observable<VehicleDtoListBaseResponse> {

    return this.apiSettingsVehiclesActiveGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoListBaseResponse>) => r.body as VehicleDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehicleIdGet
   */
  static readonly ApiSettingsVehicleIdGetPath = '/api/Settings/vehicle/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdGet$Plain(params: {
    id: number;
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehicleIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdGet$Json(params: {
    id: number;
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehicleIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehicleIdDelete
   */
  static readonly ApiSettingsVehicleIdDeletePath = '/api/Settings/vehicle/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsVehicleIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsVehicleIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehicleRegistrationRegNumberGet
   */
  static readonly ApiSettingsVehicleRegistrationRegNumberGetPath = '/api/Settings/vehicle/registration/{regNumber}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleRegistrationRegNumberGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleRegistrationRegNumberGet$Plain$Response(params: {
    regNumber: string;
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleRegistrationRegNumberGetPath, 'get');
    if (params) {
      rb.path('regNumber', params.regNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleRegistrationRegNumberGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleRegistrationRegNumberGet$Plain(params: {
    regNumber: string;
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehicleRegistrationRegNumberGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehicleRegistrationRegNumberGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleRegistrationRegNumberGet$Json$Response(params: {
    regNumber: string;
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehicleRegistrationRegNumberGetPath, 'get');
    if (params) {
      rb.path('regNumber', params.regNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehicleRegistrationRegNumberGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsVehicleRegistrationRegNumberGet$Json(params: {
    regNumber: string;
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehicleRegistrationRegNumberGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehiclePut
   */
  static readonly ApiSettingsVehiclePutPath = '/api/Settings/vehicle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePut$Plain$Response(params?: {
    body?: VehicleDto
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePut$Plain(params?: {
    body?: VehicleDto
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehiclePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePut$Json$Response(params?: {
    body?: VehicleDto
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePut$Json(params?: {
    body?: VehicleDto
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehiclePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsVehiclePost
   */
  static readonly ApiSettingsVehiclePostPath = '/api/Settings/vehicle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePost$Plain$Response(params?: {
    body?: VehicleDto
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePost$Plain(params?: {
    body?: VehicleDto
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehiclePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsVehiclePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePost$Json$Response(params?: {
    body?: VehicleDto
  }): Observable<StrictHttpResponse<VehicleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsVehiclePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsVehiclePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsVehiclePost$Json(params?: {
    body?: VehicleDto
  }): Observable<VehicleDtoBaseResponse> {

    return this.apiSettingsVehiclePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleDtoBaseResponse>) => r.body as VehicleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotsGet
   */
  static readonly ApiSettingsDepotsGetPath = '/api/Settings/depots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<DepotDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsGet$Plain(params?: {
  }): Observable<DepotDtoListBaseResponse> {

    return this.apiSettingsDepotsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoListBaseResponse>) => r.body as DepotDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<DepotDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsGet$Json(params?: {
  }): Observable<DepotDtoListBaseResponse> {

    return this.apiSettingsDepotsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoListBaseResponse>) => r.body as DepotDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotsActiveGet
   */
  static readonly ApiSettingsDepotsActiveGetPath = '/api/Settings/depots/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotsActiveGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsActiveGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<DepotDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotsActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotsActiveGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsActiveGet$Plain(params?: {
  }): Observable<DepotDtoListBaseResponse> {

    return this.apiSettingsDepotsActiveGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoListBaseResponse>) => r.body as DepotDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotsActiveGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsActiveGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<DepotDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotsActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotsActiveGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotsActiveGet$Json(params?: {
  }): Observable<DepotDtoListBaseResponse> {

    return this.apiSettingsDepotsActiveGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoListBaseResponse>) => r.body as DepotDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotIdGet
   */
  static readonly ApiSettingsDepotIdGetPath = '/api/Settings/depot/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdGet$Plain(params: {
    id: number;
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdGet$Json(params: {
    id: number;
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotIdDelete
   */
  static readonly ApiSettingsDepotIdDeletePath = '/api/Settings/depot/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsDepotIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsDepotIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsDepotIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotPut
   */
  static readonly ApiSettingsDepotPutPath = '/api/Settings/depot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPut$Plain$Response(params?: {
    body?: DepotDto
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPut$Plain(params?: {
    body?: DepotDto
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPut$Json$Response(params?: {
    body?: DepotDto
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPut$Json(params?: {
    body?: DepotDto
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsDepotPost
   */
  static readonly ApiSettingsDepotPostPath = '/api/Settings/depot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPost$Plain$Response(params?: {
    body?: DepotDto
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPost$Plain(params?: {
    body?: DepotDto
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsDepotPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPost$Json$Response(params?: {
    body?: DepotDto
  }): Observable<StrictHttpResponse<DepotDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsDepotPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DepotDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsDepotPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsDepotPost$Json(params?: {
    body?: DepotDto
  }): Observable<DepotDtoBaseResponse> {

    return this.apiSettingsDepotPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DepotDtoBaseResponse>) => r.body as DepotDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingsGet
   */
  static readonly ApiSettingsImportMappingsGetPath = '/api/Settings/import-mappings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsGet$Plain(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsGet$Json(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingsActiveGet
   */
  static readonly ApiSettingsImportMappingsActiveGetPath = '/api/Settings/import-mappings/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsActiveGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsActiveGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsActiveGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsActiveGet$Plain(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsActiveGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsActiveGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsActiveGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsActiveGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsActiveGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsActiveGet$Json(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsActiveGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingsEquipmentGet
   */
  static readonly ApiSettingsImportMappingsEquipmentGetPath = '/api/Settings/import-mappings/equipment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsEquipmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsEquipmentGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsEquipmentGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsEquipmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsEquipmentGet$Plain(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsEquipmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsEquipmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsEquipmentGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ImportMappingDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsEquipmentGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsEquipmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingsEquipmentGet$Json(params?: {
  }): Observable<ImportMappingDtoListBaseResponse> {

    return this.apiSettingsImportMappingsEquipmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoListBaseResponse>) => r.body as ImportMappingDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingIdGet
   */
  static readonly ApiSettingsImportMappingIdGetPath = '/api/Settings/import-mapping/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdGet$Plain(params: {
    id: number;
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdGet$Json(params: {
    id: number;
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingIdDelete
   */
  static readonly ApiSettingsImportMappingIdDeletePath = '/api/Settings/import-mapping/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsImportMappingIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsImportMappingIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsImportMappingIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingPut
   */
  static readonly ApiSettingsImportMappingPutPath = '/api/Settings/import-mapping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPut$Plain$Response(params?: {
    body?: ImportMappingDto
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPut$Plain(params?: {
    body?: ImportMappingDto
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPut$Json$Response(params?: {
    body?: ImportMappingDto
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPut$Json(params?: {
    body?: ImportMappingDto
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingPost
   */
  static readonly ApiSettingsImportMappingPostPath = '/api/Settings/import-mapping';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPost$Plain$Response(params?: {
    body?: ImportMappingDto
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPost$Plain(params?: {
    body?: ImportMappingDto
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPost$Json$Response(params?: {
    body?: ImportMappingDto
  }): Observable<StrictHttpResponse<ImportMappingDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportMappingDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingPost$Json(params?: {
    body?: ImportMappingDto
  }): Observable<ImportMappingDtoBaseResponse> {

    return this.apiSettingsImportMappingPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportMappingDtoBaseResponse>) => r.body as ImportMappingDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsImportMappingsPreviewPost
   */
  static readonly ApiSettingsImportMappingsPreviewPostPath = '/api/Settings/import-mappings/preview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsPreviewPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingsPreviewPost$Plain$Response(params?: {
    body?: PreviewRequestDto
  }): Observable<StrictHttpResponse<ImportPreviewDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsPreviewPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportPreviewDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsPreviewPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingsPreviewPost$Plain(params?: {
    body?: PreviewRequestDto
  }): Observable<ImportPreviewDtoBaseResponse> {

    return this.apiSettingsImportMappingsPreviewPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ImportPreviewDtoBaseResponse>) => r.body as ImportPreviewDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsImportMappingsPreviewPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingsPreviewPost$Json$Response(params?: {
    body?: PreviewRequestDto
  }): Observable<StrictHttpResponse<ImportPreviewDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsImportMappingsPreviewPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportPreviewDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsImportMappingsPreviewPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsImportMappingsPreviewPost$Json(params?: {
    body?: PreviewRequestDto
  }): Observable<ImportPreviewDtoBaseResponse> {

    return this.apiSettingsImportMappingsPreviewPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ImportPreviewDtoBaseResponse>) => r.body as ImportPreviewDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsAuditLogsPost
   */
  static readonly ApiSettingsAuditLogsPostPath = '/api/Settings/audit-logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogsPost$Plain$Response(params?: {
    body?: AuditFilterDto
  }): Observable<StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogsPost$Plain(params?: {
    body?: AuditFilterDto
  }): Observable<AuditLogDtoPagedResultDtoBaseResponse> {

    return this.apiSettingsAuditLogsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>) => r.body as AuditLogDtoPagedResultDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogsPost$Json$Response(params?: {
    body?: AuditFilterDto
  }): Observable<StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogsPost$Json(params?: {
    body?: AuditFilterDto
  }): Observable<AuditLogDtoPagedResultDtoBaseResponse> {

    return this.apiSettingsAuditLogsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoPagedResultDtoBaseResponse>) => r.body as AuditLogDtoPagedResultDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsAuditLogIdGet
   */
  static readonly ApiSettingsAuditLogIdGetPath = '/api/Settings/audit-log/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AuditLogDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogIdGet$Plain(params: {
    id: number;
  }): Observable<AuditLogDtoBaseResponse> {

    return this.apiSettingsAuditLogIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoBaseResponse>) => r.body as AuditLogDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AuditLogDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogIdGet$Json(params: {
    id: number;
  }): Observable<AuditLogDtoBaseResponse> {

    return this.apiSettingsAuditLogIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoBaseResponse>) => r.body as AuditLogDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsAuditLogsEntityTypeEntityIdGet
   */
  static readonly ApiSettingsAuditLogsEntityTypeEntityIdGetPath = '/api/Settings/audit-logs/{entityType}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogsEntityTypeEntityIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogsEntityTypeEntityIdGet$Plain$Response(params: {
    entityType: string;
    entityId: number;
  }): Observable<StrictHttpResponse<AuditLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogsEntityTypeEntityIdGetPath, 'get');
    if (params) {
      rb.path('entityType', params.entityType, {});
      rb.path('entityId', params.entityId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogsEntityTypeEntityIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogsEntityTypeEntityIdGet$Plain(params: {
    entityType: string;
    entityId: number;
  }): Observable<AuditLogDtoListBaseResponse> {

    return this.apiSettingsAuditLogsEntityTypeEntityIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoListBaseResponse>) => r.body as AuditLogDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogsEntityTypeEntityIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogsEntityTypeEntityIdGet$Json$Response(params: {
    entityType: string;
    entityId: number;
  }): Observable<StrictHttpResponse<AuditLogDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogsEntityTypeEntityIdGetPath, 'get');
    if (params) {
      rb.path('entityType', params.entityType, {});
      rb.path('entityId', params.entityId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuditLogDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogsEntityTypeEntityIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSettingsAuditLogsEntityTypeEntityIdGet$Json(params: {
    entityType: string;
    entityId: number;
  }): Observable<AuditLogDtoListBaseResponse> {

    return this.apiSettingsAuditLogsEntityTypeEntityIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AuditLogDtoListBaseResponse>) => r.body as AuditLogDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiSettingsAuditLogPost
   */
  static readonly ApiSettingsAuditLogPostPath = '/api/Settings/audit-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogPost$Plain$Response(params?: {
    body?: AuditLogDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogPost$Plain(params?: {
    body?: AuditLogDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsAuditLogPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSettingsAuditLogPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogPost$Json$Response(params?: {
    body?: AuditLogDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiSettingsAuditLogPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSettingsAuditLogPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSettingsAuditLogPost$Json(params?: {
    body?: AuditLogDto
  }): Observable<BooleanBaseResponse> {

    return this.apiSettingsAuditLogPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
